import services from 'api/services';
import {
  GET_CHALLENGE_REQUEST,
  GET_CHALLENGE_SUCCESS,
  GET_CHALLENGE_FAILURE,
  SET_CHALLENGE_RATING_REQUEST,
  SET_CHALLENGE_RATING_SUCCESS,
  SET_CHALLENGE_RATING_FAILURE,
  GET_TOURNAMENT_PLAYBACK_REQUEST,
  GET_TOURNAMENT_PLAYBACK_SUCCESS,
  GET_TOURNAMENT_PLAYBACK_FAILURE,
  RESET_STATE,
} from './constants';
import { logError } from 'util/errors';

const { ChallengeService, CourseService } = services;

export const getChallenge = (id, type) => async (dispatch) => {
  try {
    dispatch({ type: GET_CHALLENGE_REQUEST });
    const challenge = type === 'courses' ? await CourseService.getCourse(id) : await ChallengeService.getItem(id, type);
    challenge.image =
      (challenge.category === 'exercise' || type === 'courses') &&
      challenge.backgroundImage &&
      challenge.backgroundImage.url
        ? challenge.backgroundImage.url
        : challenge.contestBackground;
    challenge.keywords = challenge.tags;
    delete challenge.backgroundImage;
    delete challenge.tags;
    dispatch({ type: GET_CHALLENGE_SUCCESS, challenge });
  } catch (ex) {
    logError(ex);
    dispatch({ type: GET_CHALLENGE_FAILURE, error: ex.message });
  }
};

export const setChallengeRating = (rating, testId) => async (dispatch) => {
  try {
    dispatch({ type: SET_CHALLENGE_RATING_REQUEST });
    await ChallengeService.setItemRating(rating, testId);
    dispatch({ type: SET_CHALLENGE_RATING_SUCCESS });
  } catch (ex) {
    logError(ex);
    dispatch({ type: SET_CHALLENGE_RATING_FAILURE, error: ex.message });
  }
};

export const getTournamentPlayback = (data) => async (dispatch) => {
  try {
    dispatch({ type: GET_TOURNAMENT_PLAYBACK_REQUEST });
    const tournamentPlaybacks = await ChallengeService.getTournamentPlayback(data);
    dispatch({ type: GET_TOURNAMENT_PLAYBACK_SUCCESS, tournamentPlaybacks });
  } catch (ex) {
    logError(ex);
    dispatch({ type: GET_TOURNAMENT_PLAYBACK_FAILURE, error: ex.message });
  }
};

export const resetState = () => async (dispatch) => {
  dispatch({ type: RESET_STATE });
};
